export default "__VITE_PUBLIC_ASSET__e1e0fd40__"